<template>
  <div class="ctn">
    <div v-if="!opened" class="icon el-icon-folder"></div>
    <div v-if="opened" class="icon el-icon-folder-opened"></div>
    <div class="name">{{dir.Name}}</div>
  </div>
</template>

<script>
export default {
  name: "sessionsDirLine",
  props: ["opened", "dir"]
}
</script>

<style scoped>
.ctn {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  text-align: left;
}
.icon {
  flex-grow: 0;
  flex-shrink: 0;
  margin-right: 6px;
}
.name {
  width: 12em;
  flex-grow: 0;
  flex-shrink: 0;

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>